// AI依頼関連の文言を一元管理
export const ASSIST_MESSAGES: {
  [key: string]: {
    requestTitle: string;
    header: string;
    loading: string;
  };
} = {
  FEEDBACK_MANUSCRIPT: {
    requestTitle: "この作品の感想が聞きたい！",
    header: "感想を書いたのにゃ！",
    loading: "AI感想を依頼中...",
  },
  MATCHING_COMPANY: {
    requestTitle: "この作品と相性の良い編集部を教えて！",
    header: "おすすめの編集部を見つけてきたのにゃ！",
    loading: "応募先を検索中...",
  },
  GENERATE_CATCHCOPY: {
    requestTitle: "この作品のキャッチコピーを作って！",
    header: "キャッチコピーを考えてきたのにゃ！",
    loading: "キャッチコピーを生成中...",
  },
};
